// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-b669f217a885e64e.css";
if (chunkId === "7350") return "css/7350-4c7b3d462f51a29e.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"1632": "6b3ff39c47ca4ec9","193": "cb87384067055f46","2390": "7883655edc831929","2429": "a73d2fa285645c40","2717": "c5820b193c3b10f0","4382": "19ad2818ff8fe98a","6580": "cded35efb41d2697","6773": "19ad2818ff8fe98a","9896": "a8d311b114ec77ce","9946": "9cc540d38965a97e",}[chunkId] + ".css"
}